import axiosAdminPublicInstance from "../services/axiosAdminPublicInstance";
import { COACH_CARD_UPDATE_SUCCESS } from "../entities/Endpoints";

export const coachCardUpdateApi = async (checkoutSessionId) => {
  try {
    const response = await axiosAdminPublicInstance.post(
      `${COACH_CARD_UPDATE_SUCCESS}?checkoutSession_id=${checkoutSessionId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to update coach card.");
  }
};
